import api from '../index'
import {
  IGetAreas,
  IGetAreasByProject,
  IAddAreaParams,
  IUpdateAreaParams
} from '../models/areas'

export const getAreas = (data: IGetAreas) => {
  return api.get(`/areas/${data.id}`, { params: data })
}

export const getProjectDetails = (projectId: string) => {
  return api.get(`/projects/${projectId}`)
}

export const getAreasByProject = (
  projectId: string,
  data?: IGetAreasByProject
) => {
  return api.get(`/areas/${projectId}`, { params: data })
}

export const addArea = (data: IAddAreaParams) => {
  return api.post(`/areas`, data)
}

export const getArea = (id: string) => {
  return api.get(`/areas/${id}`)
}

export const editArea = (data: IUpdateAreaParams) => {
  return api.put(`/areas`, data)
}

export const archiveArea = (ids: Array<string>) => {
  return api.delete('/areas', { data: { ids } })
}

export const activateArea = (data: { ids: string[] }) => {
  return api.patch('/areas/recover', data)
}

export const duplicateArea = (data: { id: string }) => {
  return api.post(`/areas/duplicate/${data.id}`)
}

export const copyArea = (data: { id: string; projectId: string }) => {
  return api.post(`/areas/copy/${data.id}/project/${data.projectId}`)
}
